import {doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export class Type
{
	constructor(name)
	{
		this.name = name;
		this.id = name;
	}

	async submitAsNew()
	{
		const {id, ...rest} = this;
		var projectRef = doc(db, "Types", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Types", id), { ...rest });
			return resp;
		}
	}

	static async submitUpdate(p)
	{
		const {id, ...rest} = p;
		let resp = await setDoc(doc(db, "Types", id), { ...rest });
		return resp;
	}

	static async getAll()
	{
		return await getCollection("Types");
	}

	static async deleteAndUpdate(selection,types,setTypes)
	{
		types = types.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Types", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setTypes(types);
	}
}